import styles from "./styles.module.css";

export default function PageContainer({
  children,
}: {
  children: JSX.Element | JSX.Element[] | undefined;
}) {
  return <div className={styles.container}>{children}</div>;
}
